import { Fragment } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import usePage from "../hooks/usePage";
import Footer from "../modules/public/footer/footer";
import Menu from "../modules/public/menu/menu";

function PeykPage() {
  const { pageSliders, pageImage, pageText } = usePage();

  return (
    <Fragment>
      <Menu />

      {pageSliders}

      <div className="content-all">
        <Container>
          {pageText}

          <div className="home-request-page my-5">
            <Link to="/avabox" id="externalBotton" className="d-flex px-5 py-2">
              <p className="home-request-style">ثبت سفارش</p>
            </Link>
          </div>
        </Container>
      </div>

      {pageImage}

      <Footer />
    </Fragment>
  );
}

export default PeykPage;
